export enum SystemNotificationsTypeEnum {
    info = 'INFORMATION',
    important = 'IMPORTANT',
    critical = 'CRITICAL',
    maintenance = 'MAINTENANCE'
}
